const SETTINGS = [
    {
        label: 'تماس با ما',
        name: 'CONTACT',
        code: 101,
        color: '',
        groups: ['info'],
        schema: {
            fields: [
                {
                    'name': 'text',
                    'label': 'متن',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'درباره',
        name: 'ABOUT',
        code: 100,
        color: '',
        groups: ['info'],
        schema: {
            fields: [
                {
                    'name': 'text',
                    'label': 'متن',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'عنوان سایت',
        name: 'SITE_TITLE',
        code: 102,
        color: '',
        groups: ['info'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'text',
                    'label': 'متن',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'درباره سایت (meta)',
        name: 'SITE_DESC',
        code: 103,
        color: '',
        groups: ['info'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'text',
                    'label': 'متن',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'تنظیمات RSS',
        name: 'RSS_SETT',
        code: 104,
        color: '',
        groups: ['features'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'title',
                    'label': 'تیتر',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'label': 'درباره',
                    'name': 'description',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'managingEditor',
                    'label': 'سردبیر',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'webMaster',
                    'label': 'وب مستر',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                }
            ]
        },
    },
    {
        label: 'تنظیمات Push',
        name: 'PUSH_SETT',
        code: 105,
        color: '',
        groups: ['features'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'manifestjson',
                    'label': 'Manifest.json',
                    'type': 'textarea',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'serviceworkername',
                    'label': 'نام Service Worker',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'serviceworker',
                    'label': 'Service Worker',
                    'type': 'textarea',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'script',
                    'label': 'اسکریپت راه انداز',
                    'type': 'textarea',
                    'validation': {},
                    'layout': {}
                },

            ]
        },
    },
    {
        label: 'گوگل آنالیتیک',
        name: 'GA_SETT',
        code: 106,
        color: '',
        groups: ['integrations'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'code',
                    'label': 'شناسه آنالیتیکس',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'UMAMI',
        name: 'UMAMI_SETT',
        code: 107,
        color: '',
        groups: ['integrations'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'url',
                    'label': 'آدرس اسکریپت',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'websiteid',
                    'label': 'Website Id',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'Google Sign-In',
        name: 'GOOGLE_AUTH',
        code: 108,
        color: '',
        groups: ['integrations'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'clientId',
                    'label': 'Client Id',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'clientSecret',
                    'label': 'Client Secret',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'Kavehnegar SMS',
        name: 'KAVEHNEGAR_API',
        code: 109,
        color: '',
        groups: ['integrations', 'sms'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'number',
                    'label': 'sender number',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'apikey',
                    'label': 'Api Key',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'Mellipayamak SMS',
        name: 'MELLIPAYAMAK_API',
        code: 110,
        color: '',
        groups: ['integrations', 'sms'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'number',
                    'label': 'sender number',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'username',
                    'label': 'Username',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'password',
                    'label': 'Password',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'لوگوی پنل',
        name: 'PANEL_LOGO',
        code: 111,
        color: '',
        groups: ['ui',],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'id',
                    'label': 'شناسه فایل لوگو',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
    {
        label: 'SMS1 SMS',
        name: 'SMS1_API',
        code: 112,
        color: '',
        groups: ['integrations', 'sms'],
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'token',
                    'label': 'Token',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
            ]
        },
    },
]

SETTINGS.byName = (name) => SETTINGS.find(s => s.name === name)
SETTINGS.byCode = (code) => {
    const codeNum = Number(code)
    return SETTINGS.find(s => s.code === codeNum)
}

export { SETTINGS }